import { useEffect, useRef } from 'react';

/**
 * Calls `fn` every `intervalMs` while enabled. Skips a cycle if the previous
 * call is still running, and pauses while the tab is hidden.
 */
export function usePolling(
  fn: () => Promise<void> | void,
  intervalMs: number,
  enabled = true
) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    if (!enabled) return undefined;
    let busy = false;
    const id = setInterval(async () => {
      if (busy || document.visibilityState === 'hidden') return;
      busy = true;
      try {
        await fnRef.current();
      } catch {
        // Next cycle tries again.
      } finally {
        busy = false;
      }
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, enabled]);
}
